import React, { Component } from 'react'
import homePageImage from '../../assets/images/homePageImage.png'
import slidShowImg1 from '../../assets/images/conversationFirst.png'
import slidShowImg2 from '../../assets/images/conversationSecond.png'
import slidShowImg3 from '../../assets/images/conversationThird.png'
// import homePageVideo from '../../assets/videos/wall e-_1.mp4'
import { Button } from '@mui/material'
import './home.styles.css'
import { Redirect } from 'react-router'
import { withRouter } from "react-router";

class Home extends Component {
    constructor(props) {
        super(props);

        this.props = props
        this.state = {
            startPresenting: false,
            slideToShow: 1
        }

        this.videoElement = null
    }

    videoEnded = (evt) => {
        console.log("video ended : ", evt)
        this.setState({
            slideToShow: (this.state.slideToShow + 1)
        }, () => {
            console.log("this.state.slideToShow", this.state.slideToShow)
        })
    }

    componentDidMount() {
        console.log("this.state.startPresenting", this.state.startPresenting)

        let interval = setInterval(() => {
            if (this.videoElement) {
                this.videoElement.addEventListener("ended", this.videoEnded);
                console.log('this.videoElement : ', this.videoElement)
                clearInterval(interval)
            }
        }, 200)
    }

    startVideo = (evt) => {
        console.log("clicked on saveTheDayBtn", this.state.startPresenting)
        this.setState({
            startPresenting: true
        }, () => {
            console.log("this.state.startPresenting", this.state.startPresenting)
        })
    }

    nextSlide = (evt) => {
        console.log("clicked on saveTheDayBtn", this.state.slideToShow)
        this.setState({
            slideToShow: this.state.slideToShow + 1
        }, () => {
            console.log("this.state.slideToShow", this.state.slideToShow)
        })
    }

    render() {
        let { startPresenting, slideToShow } = this.state;

        let componentToBeRendered = null
        if (startPresenting) {
            if (slideToShow === 1) {
                componentToBeRendered = (
                    <div className="homePageVideo">
                        <video ref={el => this.videoElement = el} controls autostart autoPlay src="https://static.cctech.co.in/who-saves-the-day/app-intro-video.mp4" type="video/mp4" />
                    </div>
                )
            }
            else if (slideToShow === 2) {
                componentToBeRendered = (
                    <div className="homePageImage">
                        <img src={slidShowImg1} alt="fireSpot" />
                        <div className="nexBtn">
                            <Button
                                variant="contained"
                                onClick={this.nextSlide}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
            }
            else if (slideToShow === 3) {
                componentToBeRendered = (
                    <div className="homePageImage">
                        <img src={slidShowImg2} alt="fireSpot" />
                        <div className="nexBtn">
                            <Button
                                variant="contained"
                                onClick={this.nextSlide}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
            }
            else if (slideToShow === 4) {
                componentToBeRendered = (
                    <div className="homePageImage">
                        <img src={slidShowImg3} alt="fireSpot" />
                        <div className="nexBtn">
                            <Button
                                variant="contained"
                                onClick={this.nextSlide}
                            >
                                Next
                            </Button>
                        </div>
                    </div>
                )
            }
            else {
                componentToBeRendered = (<Redirect to="/map"></Redirect>)
            }
        }
        else {
            componentToBeRendered = (
                <div id="homePageImage" className="homePageImage">
                    <img src={homePageImage} alt="fireSpot" />
                    <div className="saveTheDayBtn">
                        <Button
                            variant="contained"
                            onClick={this.startVideo}
                        >
                            Save The Day
                        </Button>
                    </div>
                </div>
            )
        }

        return (
            <div id="homeRoot" className="homeRoot">
                {componentToBeRendered}
            </div>
        )
    }
}

export default withRouter(Home)